import React, { memo } from "react";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import { Field } from "react-final-form";
import FormHelperText from "@mui/material/FormHelperText";

const UiSelect = memo((props) => {
     const { label, value, handleChange, options } = props;

     return (
          <Field
               name={props.name}
               defaultValue={props.value}
               render={({ input, meta }) => {
                    return (
                         <FormControl fullWidth error={meta.error}>
                              <InputLabel id="demo-simple-select-label">
                                   {label}
                              </InputLabel>
                              <Select
                                   {...props}
                                   {...input}
                                   label={label}
                                   onChange={(event) => {
                                        if (
                                             typeof props.onChange !=
                                             "undefined"
                                        ) {
                                             props.onChange(event.target.value);
                                        }

                                        input.onChange(event);
                                   }}
                              >
                                   {options.map((item) => (
                                        <MenuItem
                                             key={item.value}
                                             value={item.value}
                                        >
                                             {item.label}
                                        </MenuItem>
                                   ))}
                              </Select>
                              {meta.error && (
                                   <FormHelperText className="component-error-text">
                                        {meta.error}
                                   </FormHelperText>
                              )}
                         </FormControl>
                    );
               }}
          />
     );
});

export default UiSelect;
